import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const HandwrittenTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={`${containerClass} font-sans`}>
        {/* Paper Texture Effect */}
        <div className="absolute inset-0 bg-warning-50 opacity-50 z-0 pointer-events-none"></div>

        <div className="relative z-10 p-12 h-full flex flex-col">
            {!hideHeader && (
              <>
                <div className="text-center mb-12 border-b-4 border-neutral-800 border-dashed pb-8 transform -rotate-1">
                    <LogoImage size="md" className="mx-auto mb-4 border-2 border-neutral-800 rounded-full p-2" />
                    <h1 className="text-4xl font-black text-neutral-800 tracking-tight uppercase">{profile.name}</h1>
                    <p className="text-neutral-500 font-medium italic mt-2">"{profile.email}"</p>
                </div>

                <div className="flex justify-between items-start mb-12">
                    <div className="w-1/2 bg-white border-2 border-neutral-800 p-6 rounded-lg shadow-[4px_4px_0px_rgba(30,41,59,1)] transform rotate-1">
                        <p className="font-bold text-xs uppercase text-neutral-400 mb-2">To:</p>
                        {client ? (
                            <div>
                                <p className="font-bold text-xl">{client.name}</p>
                                <p className="text-neutral-600">{client.company}</p>
                            </div>
                        ) : <p className="text-neutral-300">No Client</p>}
                    </div>
                    <div className="text-right">
                        <h2 className="text-5xl font-black text-neutral-200 uppercase mb-4">{type}</h2>
                        <div className="space-y-1">
                            {metaData.map((m, i) => (
                                <div key={i}>
                                    <span className="font-bold text-neutral-800 mr-2">{m.label}:</span>
                                    <span className="underline decoration-wavy decoration-slate-300">{m.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
              </>
            )}

            <div className="flex-1 handwritten-table border-2 border-neutral-800 rounded-lg p-6 bg-white">
                {children}
            </div>

            <div className="mt-8 text-center text-neutral-500 font-medium italic transform rotate-1">
                {footerNote}
            </div>
        </div>
    </div>
  );
};

export default HandwrittenTemplate;